import React from "react";

function NotFound() {
  return (
    <div>
      <h1>Page does not exist</h1>
    </div>
  );
}

export default NotFound;
